import React, { useState, useEffect, useContext } from "react";
import { Label, Form, FormGroup, Row, Col, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import { formatDateTime, getCarTypes, getCorporateClientsBySeviceCityIdAndTravelType, getUserDetails, showAlert } from "../../Services/Shared.service";
import { createPackage, getPackage, getTaxGroupList } from "../../Services/Packages.service";
import { createCorporateClient, getCorporateClient, updateCorporateClient } from "../../Services/CorporateClient.service";
import { ArrowDown, ArrowUp } from "react-feather";
import { CommonModal } from "../../AbstractElements";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { getExternalThirdParty,createExternalThirdPartyClient,updateExternalThirdPartyClient } from "../../Services/ExternalThirdParty.service";

const ExternalThirdpartyInput = ({ cityData, editId, setIsOpen, fetchTableData, isOpen }) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset
    } = useForm({
        // defaultValues: {
        //     isMegaCabsCompany: false,
        //     serviceCity: "",
        //     companyName: "",
        //     panNo: "",
        //     serviceTaxNo: "",
        //     contactPerson: "",
        //     mobile: "",
        //     email: "",
        //     addressLine: "",
        //     city: "",
        //     state: "",
        //     pincode: "",
        //     fax: "",
        //     billingAddress: "",
        //     billingCity: "",
        //     billingState: "",
        //     billingPincode: "",
        //     billingContactPerson: "",
        //     billingContactMobile: "",
        //     discountValue: "",
        //     discountType: "",
        //     baseFareTax: "",
        //     serviceTax: "",
        //     isAirportClient: false,
        //     airportCharge: "",
        //     a2c: false,
        //     c2a: false,
        //     isWalletEnabled: false
        // },
    });
    const values = getValues()
    const [taxData, setTaxData] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [ExternalClientObj, setExternalClientObj] = useState({})
    const [isAdvanced, setIsAdvanced] = useState(false)
    const {mix_background_layout} = useContext(CustomizerContext)

    const serviceCityField = useController({
        name: "serviceCity",
        control,
        rules: {
            required: {
                value: true,
                message: "Service City is Required",
            },
        },
    }).field;

    const handleServiceCitySelectChange = (data) => {
        serviceCityField.onChange(data.value);
    };

    const isMegaCabsCompanyField = useController({
        name: "isMegaCabsCompany",
        control,
    }).field;

    const isWalletEnabledField = useController({
        name: "isWalletEnabled",
        control,
    }).field;

    const isAirportClientField = useController({
        name: "isAirportClient",
        control,
    }).field;

    const a2cField = useController({
        name: "a2c",
        control,
    }).field;

    const c2aField = useController({
        name: "c2a",
        control,
    }).field;

    const mobileField = useController({
        name: "mobile",
        control,
        rules: {
            required: {
                value: true,
                message: "Mobile Number is Required",
            },
        },
    }).field;

    const billingMobileField = useController({
        name: "billingContactMobile",
        control,
    }).field;

    const discountValueField = useController({
        name: "discountValue",
        control,
    }).field;

    const airportChargeField = useController({
        name: "airportCharge",
        control,
    }).field;


    const baseFareTaxField = useController({
        name: "baseFareTax",
        control,
        rules: {
            required: {
                value: true,
                message: "Base Fare Tax is Required",
            },
        },
    }).field;

    const handleBaseFareTax = (data) => {
        baseFareTaxField.onChange(data.value);
    };

    const serviceTaxField = useController({
        name: "serviceTax",
        control,
        rules: {
            required: {
                value: true,
                message: "Service Tax is Required",
            },
        },
    }).field;

    const handleServiceFareTax = (data) => {
        serviceTaxField.onChange(data.value);
    };

    useEffect(() => {
        getTaxGroupList().then((result) => {
            if (result.status == 200) {
                const data = result.data.map((element) => {
                    return {
                        value: element,
                        label: element.name,
                    };
                });
                setTaxData(data);
            }
        });
    }, [])

    useEffect(() => {
        if (editId) {
            getExternalThirdParty(editId).then((resp) => {
                let ExternalClientObj = resp.data
                setExternalClientObj(ExternalClientObj)
                const serviceCity = cityData.find((element) => {
                    return element?.value?.id === ExternalClientObj?.serviceCityId;
                })
                console.log("service city", serviceCity)
                reset({
                    isMegaCabsCompany: ExternalClientObj?.isMegaCabsCompany ? true : false,
                    serviceCity: serviceCity?.value?.id ? serviceCity?.value : "",
                    companyName: ExternalClientObj?.companyName ? ExternalClientObj.companyName : "",
                    panNo: ExternalClientObj?.panNo ? ExternalClientObj.panNo : "",
                    serviceTaxNo: ExternalClientObj?.serviceTaxNo ? ExternalClientObj.serviceTaxNo : "",
                    contactPerson: ExternalClientObj?.contactPerson ? ExternalClientObj.contactPerson : "",
                    mobile: ExternalClientObj?.mobile ? ExternalClientObj.mobile : "",
                    email: ExternalClientObj?.email ? ExternalClientObj.email : "",
                    addressLine: ExternalClientObj?.addressLine ? ExternalClientObj.addressLine : "",
                    city: ExternalClientObj?.city ? ExternalClientObj.city : "",
                    state: ExternalClientObj?.state ? ExternalClientObj.state : "",
                    pincode: ExternalClientObj?.pincode ? ExternalClientObj.pincode : "",
                    fax: ExternalClientObj?.fax ? ExternalClientObj.fax : "",
                    billingAddress: ExternalClientObj?.billingAddress ? ExternalClientObj.billingAddress : "",
                    billingCity: ExternalClientObj?.billingCity ? ExternalClientObj.billingCity : "",
                    billingState: ExternalClientObj?.billingState ? ExternalClientObj.billingState : "",
                    billingPincode: ExternalClientObj?.billingPincode ? ExternalClientObj.billingPincode : "",
                    billingContactPerson: ExternalClientObj?.billingContactPerson ? ExternalClientObj.billingContactPerson : "",
                    billingContactMobile: ExternalClientObj?.billingContactMobile ? ExternalClientObj.billingContactMobile : "",
                    discountValue: ExternalClientObj?.discountValue ? ExternalClientObj.discountValue : "",
                    discountType: ExternalClientObj?.discountType ? ExternalClientObj.discountType : "",
                    baseFareTax: ExternalClientObj?.baseFareTaxId ? { id: ExternalClientObj?.baseFareTaxId } : "",
                    serviceTax: ExternalClientObj?.serviceTaxId ? { id: ExternalClientObj?.serviceTaxId } : "",
                    isAirportClient: ExternalClientObj?.isAirportClient ? true : false,
                    airportCharge: ExternalClientObj?.airportCharge ? ExternalClientObj.airportCharge : "",
                    a2c: ExternalClientObj?.a2c ? true : false,
                    c2a: ExternalClientObj?.c2a ? true : false,
                    isWalletEnabled: ExternalClientObj?.isWalletEnabled ? true : false,
                    createdOn:ExternalClientObj.createdOn?ExternalClientObj.createdOn:null,
                })
            }).catch((err) => {
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
            });
        }
    }, [editId])

    console.log("values", values)

    const onFormSubmit = (formValues) => {
        const userDetails = getUserDetails();
        setIsSubmitting(true)
        const body = {
            sapGlCode: null,
            isMegaCabsCompany: formValues.isMegaCabsCompany ? true : false,
            companyName: formValues.companyName ? formValues.companyName : null,
            companyLogo: null,
            cinNo: null,
            panNo: formValues.panNo ? formValues.panNo : null,
            serviceTaxNo: formValues.serviceTaxNo ? formValues.serviceTaxNo : null,
            contactPerson: formValues.contactPerson ? formValues.contactPerson : null,
            mobile: formValues.mobile ? formValues.mobile : null,
            email: formValues.email ? formValues.email : null,
            addressLine: formValues.addressLine ? formValues.addressLine : null,
            city: formValues.city ? formValues.city : null,
            state: formValues.state ? formValues.state : null,
            pincode: formValues.pincode ? formValues.pincode : null,
            phone1: null,
            phone2: null,
            fax: formValues.fax ? formValues.fax : null,
            billingAddress: formValues.billingAddress ? formValues.billingAddress : null,
            billingCity: formValues.billingCity ? formValues.billingCity : null,
            billingState: formValues.billingState ? formValues.billingState : null,
            billingPincode: formValues.billingPincode ? formValues.billingPincode : null,
            billingContactPerson: formValues.billingContactPerson ? formValues.billingContactPerson : null,
            billingContactMobile: formValues.billingContactMobile ? formValues.billingContactMobile : null,
            createdById: userDetails.userId,
            createdViaType: null,
            deletedOn: null,
            isDeleted: false,
            deletedById: null,
            serviceCityId: formValues.serviceCity?.id ? formValues.serviceCity.id : null,
            discountValue: formValues.discountValue ? formValues.discountValue : null,
            discountType: formValues.discountType ? formValues.discountType : null,
            baseFareTaxId: formValues.baseFareTax?.id ? formValues.baseFareTax.id : null,
            serviceTaxId: formValues.serviceTax?.id ? formValues.serviceTax.id : null,
            isAirportClient: formValues.isAirportClient ? true : false,
            lutNo: null,
            serviceDescription: formValues.serviceCity?.serviceDescription ? formValues.serviceCity.serviceDescription : null,
            sacCode: formValues.serviceCity?.sacCode ? formValues.serviceCity.sacCode : null,
            isSendSms: true,
            isSendMail: null,
            isStopInvoice: null,
            a2c: formValues.a2c ? true : false,
            c2a: formValues.c2a ? true : false,
            airportCharge: formValues.airportCharge ? Number(formValues.airportCharge) : null,
            isWalletEnabled: formValues.isWalletEnabled ? true : false,
            createdOn:formValues?.createdOn?formValues.createdOn:null
        };
        if (ExternalClientObj?.id) {
            body["id"] = ExternalClientObj?.id
            updateExternalThirdPartyClient(body)
                .then((result) => {

                    showAlert("success", "External ThirdParty Client Updated Successfully");
                    fetchTableData();
                    setIsSubmitting(false)
                    setIsOpen(false)
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                    setIsSubmitting(false)
                });
        } else {
            createExternalThirdPartyClient(body)
                .then((result) => {
                    showAlert("success", "External ThirdParty Client Created Successfully");
                    fetchTableData();
                    setIsSubmitting(false)
                    setIsOpen(false)
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                    setIsSubmitting(false)
                });
        }
    };

    const handleAirportClientChange = () => {
        setValue("isAirportClient", true)
        setValue("a2c", true)
        setValue("c2a", false)
    }

    const handleCityClientChange = () => {
        setValue("isAirportClient", false)
        setValue("a2c", false)
        setValue("c2a", true)
    }

    return (
        <CommonModal
            isOpen={isOpen}
            title={editId ? "Edit ThirdParty Client" : "Create ThirdParty Client"}
            toggler={() => {
                
                setIsOpen(!isOpen)
            }}
            size="xl"
        >
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                    <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                        <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"} style={{ display: "flex", alignItems: "center" }}>
                            <Input
                                id="isMegaCabsCompany"
                                type="checkbox"
                                checked={isMegaCabsCompanyField.value}
                                onChange={(value) => isMegaCabsCompanyField.onChange(value)}
                            />
                            <Label className="mb-0" for="isMegaCabsCompany" >{"Is MegaCabs Company"}</Label>
                        </div>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Company Name</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("companyName", {
                                    required: {
                                        value: true,
                                        message: "Company Name is required",
                                    },
                                    onChange: (e) => {
                                        setValue("companyName", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.companyName?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                        <div className="m-checkbox-inline mb-0 custom-radio-ml" style={{ display: "flex", alignItems: "center" }}>
                            <div className="radio radio-primary">
                                <Input id="radioinline2" type="radio" name="airportClient" checked={isAirportClientField.value} onChange={handleAirportClientChange} />
                                <Label className="mb-0" for="radioinline2">{"Airport Client"}</Label>
                            </div>
                            <div className="radio radio-primary">
                                <Input id="radioinline3" type="radio" name="cityClient" checked={c2aField.value} onChange={handleCityClientChange} />
                                <Label className="mb-0" for="radioinline3">{"City Client"}</Label>
                            </div>
                        </div>
                    </FormGroup>
                    <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                        <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"} style={{ display: "flex", alignItems: "center" }}>
                            <Input
                                id="isWalletEnabled"
                                type="checkbox"
                                checked={isWalletEnabledField.value}
                                onChange={(value) => isWalletEnabledField.onChange(value)}
                            />
                            <Label className="mb-0" for="isWalletEnabled" >{"Wallet Enabled"}</Label>
                        </div>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Service City</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <CustomSelect
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={serviceCityField?.value?.id ? cityData.find((element) => {
                                        return element?.value?.id === serviceCityField?.value?.id;
                                    }) : ""}
                                    isDisabled={ExternalClientObj?.id ? true : false}
                                    // defaultValue={cityData.find((element) => {
                                    //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                    //   return element?.value?.id === cityField?.value?.id;
                                    // })}
                                    onChange={handleServiceCitySelectChange}
                                    placeholder="Select City"
                                    options={cityData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.serviceCity?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Contact Person</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("contactPerson", {
                                    required: {
                                        value: true,
                                        message: "Contact Person is required",
                                    },
                                    onChange: (e) => {
                                        setValue("contactPerson", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.contactPerson?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Mobile Number</Label>
                        <Col lg="12">
                            <input
                                type="text"
                                className="form-control"
                                maxLength={10}
                                value={mobileField.value}
                                pattern="[0-9]+"
                                onChange={(e) => {
                                    mobileField.onChange(e.target.value.replace(/[^0-9]/g, ''))
                                }}
                            />
                            <span style={{ color: "red" }}>{errors?.mobile?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Email</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("email", {
                                    onChange: (e) => {
                                        setValue("email", e.target.value.trimStart())
                                    },
                                    required: {
                                        value: true,
                                        message: "Email is required",
                                    },
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                        message: "Please enter a valid email !",
                                    },
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.email?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Address</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("addressLine", {
                                    required: {
                                        value: true,
                                        message: "Address is required",
                                    },
                                    onChange: (e) => {
                                        setValue("addressLine", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.addressLine?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">City</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("city", {
                                    required: {
                                        value: true,
                                        message: "City is required",
                                    },
                                    onChange: (e) => {
                                        setValue("city", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.city?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">State</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("state", {
                                    required: {
                                        value: true,
                                        message: "State is required",
                                    },
                                    onChange: (e) => {
                                        setValue("state", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.state?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Base Fare Tax</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <CustomSelect
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={baseFareTaxField?.value?.id ? taxData.find((element) => {
                                        return element?.value?.id === baseFareTaxField?.value?.id;
                                    }) : ""}
                                    // defaultValue={cityData.find((element) => {
                                    //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                    //   return element?.value?.id === cityField?.value?.id;
                                    // })}
                                    onChange={handleBaseFareTax}
                                    placeholder="Select Base Fare Tax"
                                    options={taxData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.baseFareTax?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Service Tax</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <CustomSelect
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={serviceTaxField?.value?.id ? taxData.find((element) => {
                                        return element?.value?.id === serviceTaxField?.value?.id;
                                    }) : ""}
                                    //   // defaultValue={cityData.find((element) => {
                                    //   //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                    //   //   return element?.value?.id === cityField?.value?.id;
                                    //   // })}
                                    onChange={handleServiceFareTax}
                                    placeholder="Select Service Tax"
                                    options={taxData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.serviceTax?.message}</span>
                        </Col>
                    </FormGroup>
                </Row>
                <Row>
                    <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
                </Row>
                {isAdvanced ? <Row>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Pan Number</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("panNo", {
                                    onChange: (e) => {
                                        setValue("panNo", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.panNo?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Service Tax Number</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("serviceTaxNo", {
                                    onChange: (e) => {
                                        setValue("serviceTaxNo", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.serviceTaxNo?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Pincode</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("pincode", {
                                    onChange: (e) => {
                                        setValue("pincode", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.pincode?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Fax</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("fax", {
                                    onChange: (e) => {
                                        setValue("fax", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.fax?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Billing Address</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("billingAddress", {
                                    onChange: (e) => {
                                        setValue("billingAddress", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.billingAddress?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Billing City</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("billingCity", {
                                    onChange: (e) => {
                                        setValue("billingCity", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.billingCity?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Billing State</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("billingState", {
                                    onChange: (e) => {
                                        setValue("billingState", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.billingState?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Billing Pincode</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("billingPincode", {
                                    onChange: (e) => {
                                        setValue("billingPincode", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.billingPincode?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Billing Contact Person</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("billingContactPerson", {
                                    onChange: (e) => {
                                        setValue("billingContactPerson", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.billingContactPerson?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Billing Contact Mobile</Label>
                        <Col lg="12">
                            <input
                                type="text"
                                className="form-control"
                                maxLength={10}
                                value={billingMobileField.value}
                                pattern="[0-9]+"
                                onChange={(e) => {
                                    billingMobileField.onChange(e.target.value.replace(/[^0-9]/g, ''))
                                }}
                            />
                            <span style={{ color: "red" }}>{errors?.billingContactMobile?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Discount Value</Label>
                        <Col lg="12">
                            <input
                                type="text"
                                className="form-control"
                                value={discountValueField.value}
                                pattern="[0-9]+"
                                onChange={(e) => {
                                    discountValueField.onChange(e.target.value.replace(/[^0-9]/g, ''))
                                }}
                            />
                            <span style={{ color: "red" }}>{errors?.discountValue?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Discount Type</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("discountType", {
                                    onChange: (e) => {
                                        setValue("discountType", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.discountType?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Airport Charge</Label>
                        <Col lg="12">
                            <input
                                type="text"
                                className="form-control"
                                value={airportChargeField.value}
                                pattern="[0-9]+"
                                onChange={(e) => {
                                    airportChargeField.onChange(e.target.value.replace(/[^0-9]/g, ''))
                                }}
                            />
                            <span style={{ color: "red" }}>{errors?.airportCharge?.message}</span>
                        </Col>
                    </FormGroup>
                </Row> : null}


                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" className="btn submit-button" disabled={isSubmitting}>
                        {ExternalClientObj?.id ? "Update" : "Create"}
                    </button>
                </div>
            </Form>
        </CommonModal>
    )
}

export default ExternalThirdpartyInput